module.exports = __webpack_public_path__ + "img/vk.4c91114.svg";